import { render, staticRenderFns } from "./SecondarySkills.vue?vue&type=template&id=4054cf08&"
import script from "./SecondarySkills.vue?vue&type=script&lang=js&"
export * from "./SecondarySkills.vue?vue&type=script&lang=js&"
import style0 from "./SecondarySkills.vue?vue&type=style&index=0&id=4054cf08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports